<template>
  <div v-if="!loader && loaded">
    <Template1 v-if="facility.template == 1" :data="content" />
    <Template2 v-else-if="facility.template == 2" :data="facility" />
    <Template3 v-else-if="facility.template == 3" :data="facility" />
    <Template4 v-else-if="facility.template == 4" :data="content" />
    <Template5 v-else-if="facility.template == 5" :data="content" />
    <Template6 v-else-if="facility.template == 6" :data="facility" />
    <Template7 v-else-if="facility.template == 7" :data="content" />
    <Template8 v-else-if="facility.template == 8" :data="facility" />
    <Template9 v-else-if="facility.template == 9" :data="content" />
    <Template10 v-else-if="facility.template == 10" :data="facility" />
  </div>
</template>
<script>
import api from "../../api";
import Template1 from "./Template1.vue";
import Template2 from "./Template2.vue";
import Template3 from "./Template3.vue";
import Template4 from "./Template4.vue";
import Template5 from "./Template5.vue";
import Template6 from "./Template6.vue";
import Template7 from "./Template7.vue";
import Template8 from "./Template8.vue";
import Template9 from "./Template9.vue";
import Template10 from "./Template10.vue";

export default {
  name: "TemplateComponent",
  components: {
    Template1,
    Template2,
    Template3,
    Template4,
    Template5,
    Template6,
    Template7,
    Template8,
    Template9,
    Template10,
  },
  data() {
    return {
      facility: null,
      content: null,
      loaded: false,
    };
  },
  created() {},
  computed: {
    loader: {
      get() {
        return this.$store.getters.loader;
      },
    },
  },
  methods: {
    async onLoadFacility(url) {
      try {
        const templates = [1, 4, 5, 7, 9];
        await this.$store.dispatch("onUpdateLoader", true);
        this.loaded = false;
        const { data } = await api.airport.post("/user/facility/detail", {
          url,
          language: this.$store.getters.language,
        });

        if (data?.data) {
          this.facility = data.data;
          if (templates.includes(this.facility.template)) {
            let result = await this.onLoadContent(this.facility._id);
            this.content = { ...result, name: this.facility.name };
            this.loaded = true;
          } else this.loaded = true;
          await this.$store.dispatch("onUpdateLoader", false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onLoadContent(facility) {
      try {
        const { data } = await api.airport.get(`/user/content/${facility}`);
        if (data?.data) {
          return data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    "$route.params": async function (params) {
      if (
        String(this.facility?.url).toLowerCase() !== String(`/${params.url}`)
      ) {
        this.facility = null;
        this.content = null;
        this.loaded = false;
        await this.onLoadFacility(params.url);
      }
    },
    "$store.getters.language": async function () {
      this.facility = null;
      this.content = null;
      this.loaded = false;
      await this.onLoadFacility(this.$route.params.url);
    },
  },
  async mounted() {
    await this.onLoadFacility(this.$route.params.url);
  },
};
</script>
